import React, { useEffect, useRef, useState } from 'react'

const ThumbnailInsights = ({ imageUrl }) => {
    const canvasRef = useRef(null)
    const [stats, setStats] = useState(null)
    const [error, setError] = useState(false)

    useEffect(() => {
        if (!imageUrl) return
        setStats(null)
        setError(false)

        const img = new Image()
        img.crossOrigin = 'anonymous'

        img.onload = () => {
            try {
                const canvas = canvasRef.current
                const ctx = canvas.getContext('2d')
                canvas.width = 160
                canvas.height = 90
                ctx.drawImage(img, 0, 0, 160, 90)
                const data = ctx.getImageData(0, 0, 160, 90).data

                let total = 0
                const luminances = []
                for (let i = 0; i < data.length; i += 4) {
                    const r = data[i], g = data[i + 1], b = data[i + 2]
                    const lum = 0.299 * r + 0.587 * g + 0.114 * b
                    luminances.push(lum)
                    total += lum
                }
                const avg = total / luminances.length
                const variance = luminances.reduce((sum, l) => sum + Math.pow(l - avg, 2), 0) / luminances.length
                const stdDev = Math.sqrt(variance)

                setStats({
                    brightness: Math.round((avg / 255) * 100),
                    contrast: Math.round((stdDev / 128) * 100),
                })
            } catch (err) {
                setError(true)
            }
        }
        img.onerror = () => setError(true)
        img.src = imageUrl
    }, [imageUrl])

    const getBrightnessNote = (b) => {
        if (b < 30) return { text: 'Quite dark — may look washed out or hard to see on small mobile screens', tone: 'warn' }
        if (b > 85) return { text: 'Very bright — could look overexposed, add darker elements for balance', tone: 'warn' }
        return { text: 'Good brightness balance for most screens', tone: 'good' }
    }

    const getContrastNote = (c) => {
        if (c < 20) return { text: 'Low contrast — text or subject may not stand out in the feed', tone: 'warn' }
        return { text: 'Good contrast — should stand out well against other thumbnails', tone: 'good' }
    }

    return (
        <div className="thumbnail-insights">
            <h4 className="insights-title">Thumbnail Checklist</h4>
            <canvas ref={canvasRef} style={{ display: 'none' }} />

            {error && <p className="insights-error">Could not analyze this image.</p>}

            {stats && !error && (
                <div className="insights-grid">
                    <div className={`insight-item insight-${getBrightnessNote(stats.brightness).tone}`}>
                        <span className="insight-label">Brightness: {stats.brightness}%</span>
                        <p>{getBrightnessNote(stats.brightness).text}</p>
                    </div>
                    <div className={`insight-item insight-${getContrastNote(stats.contrast).tone}`}>
                        <span className="insight-label">Contrast: {stats.contrast}%</span>
                        <p>{getContrastNote(stats.contrast).text}</p>
                    </div>
                    <div className="insight-item insight-info">
                        <span className="insight-label">Safe Zone Tip</span>
                        <p>Keep important text and faces away from the bottom-right corner — YouTube overlays the video duration badge there in search and suggestion feeds.</p>
                    </div>
                </div>
            )}

            {!stats && !error && <p className="insights-loading">Analyzing thumbnail...</p>}
        </div>
    )
}

export default ThumbnailInsights